import { render, staticRenderFns } from "./ColorHandler.vue?vue&type=template&id=90269e98&scoped=true&"
import script from "./ColorHandler.vue?vue&type=script&lang=js&"
export * from "./ColorHandler.vue?vue&type=script&lang=js&"
import style0 from "./ColorHandler.vue?vue&type=style&index=0&id=90269e98&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90269e98",
  null
  
)

export default component.exports